<template>
  <div>
    <ion-list lines="none">
      <!-- <ion-item button @click="share" disabled>
        <ion-icon color="primary" slot="start" name="share"></ion-icon>
        <ion-label>Share</ion-label>
      </ion-item> -->
      <ion-item v-if="$parent.docId" button @click="$parent.open()">
        <span class="popupmenu-icon" v-html="iconCase()"></span>
        <ion-label>View Case</ion-label>
      </ion-item>
    </ion-list>
  </div>
</template>
<script>
import Icons from '../../components/annot8/icons';
export default {
  methods: {
    share() {
      this.$ionic.dismissPopover();
    },
    iconCase() {
      return Icons['case'];
    }
  }
};
</script>
<style>
.popupmenu-icon svg{
  margin-right: 0.65em;
}
</style>
